import React from "react";

const Career = () => {
  return (
    <div>
      <h2>History</h2>
      <p>
        J. was established in 1998 with the aim of manufacturing and
        retailing quality embroidered fabrics, equal in quality to the
        best in the world, made in Pakistan. SEFAM started out with
        the Bareeze brand of embroidered designer fabrics but has
        grown to a family of 12 brands, each of which is the largest
        in its category in the Pakistan market.
      </p>
      <h2>Our Inspirations</h2>
      <p>
        For us at J., tradition and modernity are inextricably linked,
        and this is what we try to show through our designs. Our
        inspirations are drawn from all over the world and we bring
        them under one roof to show you that beauty is universal. And
        so, time and again, we push the boundaries of what is possible
        in print, embroidery & embellishments. Every single one of our
        designs is individually crafted with an intricacy of detail
        that is unmatched. Indeed, we literally use our fabrics as
        canvasses upon which we paint works of art. For us, all this
        is possible only because we see no distinction between Art and
        Design. Rather, we know that they are two sides of the same
        coin and when treated as such, work in a most beautiful
        synergy, which makes magical things possible. Our designs are
        contemporary and timeless because of their strong roots. These
        designs are original because they remind us of our pure
        origins. When you wear J.'s' designed fabrics, they will look
        good today and, with our high standards and fabric quality,
        they will look good in years to come.
      </p>

     
    </div>
  );
};

export default Career;
